import { useRootStore } from "store";

export const useIsMobile = () => {
  const {
    uiStore: { isMobile },
  } = useRootStore();

  return isMobile;
};
